export default {
    JOB_RESPONSE_RECEIVED  : 'job_response_received',
    REMOTE_REQUEST_RECEIVED: 'remote_request_received',
    JOB_NUDGE_DECLINED     : 'job_nudge_declined',
    SEND_DIRECT_MESSAGE    : 'send_direct_message',
};
